import { jsx as _jsx } from "react/jsx-runtime";
import { Tab as ChakraTab } from '@chakra-ui/react';
import { CustomTabWithImage } from './tabWithImage';
/**
 * Tab button used to activate a specific tab panel.
 * It renders a button, and is responsible for automatic and manual selection modes.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/tabs
 */
export function Tab({ imgSrc, imgAlt, imgFallbackColor, children, ...props }) {
    if (imgSrc) {
        return (_jsx(CustomTabWithImage, { imgAlt: imgAlt, imgSrc: imgSrc, imgFallbackColor: imgFallbackColor, ...props, children: children }));
    }
    return _jsx(ChakraTab, { ...props, children: children });
}
//# sourceMappingURL=tab.js.map